import { Injectable, computed, inject } from '@angular/core';
import { userModulesToCreateNavItems, userModulesToNavItems } from '@fy-web-2/shared-util';
import { AuthStore } from './auth.store';

/**
 * Read-only facade exposing nav-tree projections of the auth store's
 * `user_modules`. Lives in `state-auth` because both projections are pure
 * derivations of auth state — keeping them here avoids a state↔state
 * cross-library dependency while leaving the mapping logic in `shared-util`
 * (pure, unit-tested without DI).
 *
 * Components inject `NavigationFacade` (or, more typically, the App shell
 * does and forwards the signals to `<lib-header [items]="..." [createItems]="...">`
 * via input binding — UI libs cannot depend on state directly).
 */
@Injectable({ providedIn: 'root' })
export class NavigationFacade {
  private readonly store = inject(AuthStore);

  /** Main top-bar navigation tree (Analytics, Rate Search, Enquiries, …). */
  readonly navItems = computed(() => userModulesToNavItems(this.store.userModules()));

  /**
   * Nested tree backing the right-side `+ New` action menu in the header
   * (Rates ▸ Ratecard / Ratesheet → Quote → Booking). Empty when the tenant
   * has no create permissions, in which case the App shell can hide the button.
   */
  readonly createItems = computed(() => userModulesToCreateNavItems(this.store.userModules()));
}
